import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Platforms from './components/Platforms';
import About from './components/About';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <div className="App">
      {process.env.NODE_ENV === 'production' && <Analytics mode="production" />}
      <div className="page-glow" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Platforms />
        <About />
        <Services />
        <Testimonials />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
